import './App.css';
import { Routes, Route } from 'react-router-dom';
import Main from './Sites/main';  
import Account from './Sites/Account';
import Cart from './Sites/Cart';
import Products from './Sites/Products';
import Checkout from './Sites/Checkout';
import Item from './Sites/Item';
import { CheckoutProvider } from './Context/CheckoutContext';
import Overview from './Sites/Overview';
import { AuthProvider } from './Context/AuthProvider';
import { CartProvider } from './Context/CartProvider';
import ResetPassword from './Components/Account/ResetPassword';
import PaymentReview from './Sites/PaymentReview';
import CompanyProducts from './Sites/CompanyProducts';
import OrderConfirmation from './Components/Checkout/OrderConfirmation';
import Infos from './Sites/Infos';
import TestPayment from './Sites/TestPayment';
import ThankYou from './Sites/ThankYou';
import Contact from './Sites/Contact';
import About from './Sites/About';
import Impressum from './Sites/Impressum';
import Sendback from './Sites/Sendback';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <CheckoutProvider>
          <div className="App">
            <Routes>
              <Route path='/' element={<Main/>}/>
              <Route path='/termekek/:category' element={<Products/>}/> 
              <Route path='/termekek/:category/:subcategory' element={<Products/>}/>         
              <Route path='/gyartok/:company' element={<CompanyProducts/>}/>
              <Route path='/termek/:category/:subcategory/:name/:id' element={<Item/>}/>
              <Route path='/fiok' element={<Account/>}/>
              <Route path='/kosar' element={<Cart/>}/>
              <Route path='/fizetes/szallitas' element={<Checkout/>}/>
              <Route path='/fizetes/osszegzes' element={<Overview/>}/>
              <Route path='/jelszovisszaallitas/:token' element={<ResetPassword/>}/>
              <Route path='/fizetes-visszaigazolas' element={<PaymentReview/>}/>
              <Route path='/rendeles-visszaigazolas' element={<OrderConfirmation/>}/>
              <Route path='/fizetes-szallitas' element={<Infos/>}/>
              <Route path='/teszt-fizetes' element={<TestPayment/>}/>
              <Route path='/koszonjuk' element={<ThankYou/>}/>
              <Route path='/kapcsolat' element={<Contact/>}/>
              <Route path='/rolunk' element={<About/>}/>
              <Route path='/impresszum' element={<Impressum/>}/>
              <Route path='/visszakuldes' element={<Sendback/>}/>
            </Routes>
          </div>
        </CheckoutProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;